import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex } from 'reflexbox';

// TODO: should replace these with svg
import iconLearners from './images/image1.png';
import iconCourses from './images/image2.png';
import iconInstitutions from './images/image3.png';
import iconPrivateCourses from './images/image4.png';

import { PlatformStat } from './PlatformStat/index';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../Style/breakpoints';

const Container = styled(Flex)`
  flex-direction: column;
  padding: 60px 12px 30px 12px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    max-width: 1024px;
    margin: 0 auto;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    flex-flow: column;
  }
`;

const BadgesContainer = styled.div`
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 6px;
  grid-row-gap: 6px;
  display: grid;
  padding: 40px 0;
  @media only screen and (max-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    grid-template-columns: repeat(2, 2fr);
    grid-template-rows: 1fr;
  }
  @media only screen and (max-width: 460px) {
    svg {
      transform: scale(0.6);
    }
  }
`;

const StyledHeader = styled.div`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.01em;
  color: #041416;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-weight: 900;
    font-size: 30px;
    line-height: 120%;
  }
`;

export const GlobalCommunity = (): ReactElement => {
  return (
    <Container>
      <StyledHeader> A global community</StyledHeader>
      <BadgesContainer>
        <PlatformStat
          header="2.93M"
          description="Learners"
          icon={<img src={iconLearners} alt="" />}
        />
        <PlatformStat
          header="278"
          description="Courses"
          icon={<img src={iconCourses} alt="" />}
        />
        <PlatformStat
          header="184"
          description="Institutions"
          icon={<img src={iconInstitutions} alt="" />}
        />
        <PlatformStat
          header="4,260"
          description="Private courses"
          icon={<img src={iconPrivateCourses} alt="" />}
        />
      </BadgesContainer>
    </Container>
  );
};
